<template>
  <div class="border rounded-md overflow-hidden">
    <template
      v-for="(category, index) in categories"
      :key="index"
    >
      <div
        type="button"
        class="cursor-pointer border-b border-gray-200 focus:ring-4 focus:ring-gray-200 last:border-b-0 hover:bg-gray-50 duration-200"
        :style="open[index] ? `background-color: ${category.backgroundColor}20` : ''"
        @click="toggleAccordion(index)"
      >
        <div
          class="flex items-center justify-between w-full p-2 font-medium text-gray-500 gap-3"
          :class="`hover:bg-[${category.backgroundColor}]/20`"
        >
          <div class="flex items-center">
            <template v-if="category.icon">
              <CategoryIcon
                :name="category.name"
                :background-color="category.backgroundColor"
                :icon="category.icon"
              />
            </template>

            <h3
              class="flex items-center pl-2.5 text-gray-700 duration-200"
              :style="open[index] ? `color: ${category.backgroundColor}` : ''"
            >
              {{ category.name }}
            </h3>
          </div>

          <div
            class="duration-300 origin-center"
            :class="open[index] ? 'rotate-180' : ''"
          >
            <i class="fa-regular fa-chevron-down text-gray-900 pr-1" />
          </div>
        </div>
      </div>

      <Transition>
        <div
          v-if="open[index]"
          :id="category.id"
          class="border-b last:border-b-0"
        >
          <div class="p-5">
            <div v-html="category.writeUp" />
          </div>
        </div>
      </Transition>
    </template>
  </div>
</template>

<script setup>
import { ref } from 'vue';

import { CategoryIcon } from '@/components/category';

const props = defineProps({
  categories: {
    type: Array,
    default: null,
  },
});

const open = ref([]);

// Initialize the open array with false for each category
if (props.categories) {
  open.value = props.categories.map(() => false);
}

const toggleAccordion = (index) => {
  open.value[index] = !open.value[index];
};

</script>

<style scoped>
/*
  Enter and leave animations can use different
  durations and timing functions.
*/

</style>
